import React from 'react';
import useTheme from '@mui/material/styles/useTheme';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Modal, Box, Button, Typography } from '@mui/material';
import { useContext } from 'react';
import { AppContext } from '/@/app/AppContext';
import { Linkify } from '/@/app/linkify';


export const AgeAssessmentModal = observer(({ modalState }) => {
    const { t } = useTranslation();
    const closeCommentDialog = () => modalState.close();
    const ageState = modalState.ageAssessment;
    const modalOpen = ageState !== null;

    let dynamics = useContext(AppContext).bootstrapData?.panel_dynamics?.items?.[ageState?.xlsxId || 0];
    if (dynamics && dynamics.length === 1) {
        dynamics = null;  // don't show dynamics with one item
    }

    return (
        <Modal
            open={modalOpen}
            onClose={closeCommentDialog}
        >
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                maxHeight: '90vh',
                maxWidth: { xs: '95vw', sm: '90vw', md: '600px' },
                width: { xs: '95vw', sm: '90vw' },
                backgroundColor: 'white',
                padding: 3,
                borderRadius: 3,
                display: 'flex',
                flexDirection: 'column',
                outline: 'none',
            }}>
                {ageState &&
                    <Box sx={{ overflowY: "auto", flex: "0 1 auto", overflowX: 'hidden', marginBottom: 1 }}>
                        <Typography variant="h3" gutterBottom>{t("План действий")}</Typography>
                        <Typography variant="body1" gutterBottom>
                            <Linkify text={ageState.action_plan} />
                        </Typography>
                    </Box>
                }
                <Button sx={{ alignSelf: "center" }} onClick={closeCommentDialog}>{t("button-close")}</Button>
            </Box>
        </Modal>
    )
});
